(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bestseller-v1"] && !Shopify.designMode) return;
  try {
    
console.log("Settings: ", section.settings)

  } catch(e) { console.error(e); }
})();
})();
